import { createFetchActions } from './createFetchActions';

const fetchVideoResponsePathActions = createFetchActions('FETCH_VIDEO_RESPONSE_PATH');

export { fetchVideoResponsePathActions };
